import React from 'react';

export const LayoutContext = React.createContext<
  | { layoutRef: React.MutableRefObject<HTMLElement | null>; raw?: boolean }
  | undefined
>(undefined);
